import { writable } from "svelte/store";
export var uistate = writable({
    selectedCampaigns: [],
    selectedLocations: []
});
